<template>
  <div class="main-body">
    <div class="header">南雪一体机</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="openAdd">绑定设备</el-button>

        <div style="float:right">

          <el-input placeholder="输入姓名" v-model="name" clearable style="margin-right:10px;width:120px"></el-input>
          <el-input placeholder="输入手机号" v-model="phone" clearable style="margin-right:10px;width:140px"></el-input>
          <el-input placeholder="输入身份证号" v-model="idCard" clearable style="margin-right:10px;width:200px"></el-input>
          <el-input placeholder="输入Imei号" v-model="imei" clearable style="margin-right:10px;width:140px"></el-input>

          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="选择区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:140px;margin-right:10px"></elSelectTree>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"
                :data="tableData" :height="th" border>

        <el-table-column prop="userName" label="用户姓名"></el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="imei" label="Imei号"></el-table-column>

        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="success" size="mini"  @click="viewData(scope.$index, scope.row)">数据</el-button>
            <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Data ref="myData" v-show="showData" v-on:closeData="closeData"  v-on:getList="getList"></Data>

  </div>
</template>

<script>

import { timeStr,timefilters } from "@/common/times";
import {hex_md5, hex_md5_with_china} from "@/common/Base64MD5";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";

import Add from "../Comm/Add"
import Data from "../Comm/Data"
import elSelectTree from "@/components/ElSelectTree"


export default {
  name: "Page",
  data() {
    return {
      tableLoading:false,

      showAdd:false,
      showData:false,

      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      name:"",
      phone: "",
      imei: "",
      idCard:'',

      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      zoneValue: [],
      zoneCode: '',

    };
  },
  components: {Add,elSelectTree,Data},
  created() {
    this.th = this.$store.state.tableHeight;
    this.getZone();
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    openAdd: function () {
      this.showAdd = !this.showAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showAdd = !this.showAdd;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },


    getZoneValue(val) {
      this.zoneCode = val
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1
      this.tableLoading=true

      let data = {
        timeStr: timeStr,
        sign: '',
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        phone: this.phone,
        imei: this.imei,
        name:this.name,
        idCard:this.idCard,
        zoneCode:this.zoneCode,
        governmentCode:getGovernmentCode(),
      };

      data.sign = '';
      data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceNanXue/PageByZoneCode",
        data: data
      }).then((response) => {
        //console.log(response.data.data);

        this.tableLoading=false
        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },


    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        let data = {
          timeStr: timeStr,
          sign: '',
          deviceNanXueCode: row.deviceNanXueCode,
        };

        data.sign = '';
        data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceNanXue/Delete",
          data: data
        }).then((response) => {
          //console.log(response);

          if (response.data.error == 0) {
            this.$message({message: "解绑成功", type: "success",});
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }

        }).catch(function (error) {
          console.log(error);
        });


      }).catch(() => {
        this.$message({type: "info", message: "已取消解绑",});
      });

    },


    getZone(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        //console.log(response.data.data);
        if (response.data.error == 0) {
          var data = JSON.stringify(response.data.data);

          //console.log(data.replace(/"listZoneDTO":\[\],/g, ''));

          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;
          this.zoneCode = data[0].zoneCode;

          this.getList();

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },

    viewData(index,row){
      this.showData = !this.showData;
      this.$refs.myData.init(row.userCode);
    },
    closeData:function(){
      this.showData = !this.showData;
    },


  },
};
</script>

<style scoped>

</style>
